import {
  ApplicationConfig, inject,
  provideAppInitializer,
  provideBrowserGlobalErrorListeners,
  provideZoneChangeDetection
} from '@angular/core';
import {
  InMemoryScrollingFeature,
  InMemoryScrollingOptions,
  provideRouter,
  withInMemoryScrolling
} from '@angular/router';

import { routes } from './app.routes';
import { HTTP_INTERCEPTORS, provideHttpClient, withFetch, withInterceptorsFromDi } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { TokenInterceptor } from '@data-access/interceptors/token.interceptor';
import { UsersStore } from '@data-access/user/stores/users.store';

import { AuthService } from '@data-access/user/services/auth.service';
import { LibraryStore } from '@data-access/user/stores/library.store';
import { PlaylistsStore } from '@data-access/user/stores/playlists.store';

function intializeAppFn() {
  const store = inject(UsersStore);
  const auth = inject(AuthService);
  if (auth.getAccessToken()) {
    return store.initWithUser();
  }
  return Promise.resolve(false);
}

const scrollConfig: InMemoryScrollingOptions = {
  scrollPositionRestoration: 'top',
  anchorScrolling: 'enabled',
};

const inMemoryScrollingFeature: InMemoryScrollingFeature =
  withInMemoryScrolling(scrollConfig);

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes, inMemoryScrollingFeature),
    provideHttpClient(withInterceptorsFromDi(), withFetch()),
    UsersStore,
    LibraryStore,
    PlaylistsStore,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true
    },
    provideAppInitializer(intializeAppFn),
    provideAnimations()
  ]
};
